import type {EmailAction} from 'src/action-creators/email';
import type {NodeSchedule} from 'src/types/node-schedule';
import type {NoteWriteback} from 'src/types/note-writeback';

import type {EmailAttachment} from 'src/types/email';
import {
  RECEIVE_EMAIL_INFO,
  UPDATE_EMAIL_INFO,
  RESET,
  UPDATE_NODE_SCHEDULE,
  UPDATE_NOTE_WRITEBACK,
} from 'src/action-creators/email';
import {getDefaultNodeScheduleState} from 'src/utils/node-schedule';
import {getDefaultNoteWritebackState} from 'src/utils/note-writeback';


export type EmailState = {
  subject: string | null | undefined;
  content_json: string | null | undefined;
  content_html: string | null | undefined;
  from_name: string | null | undefined;
  from_email: string | null | undefined;
  to_email: string | null | undefined;
  cc: Array<string>;
  bcc: Array<string>;
  content_subscription_category_id: number | null | undefined;
  content_subscription_reason: string | null | undefined;
  skip_subscription_link: boolean;
  attachments: Array<EmailAttachment>;
  chatbotsAttached: Array<string>;
  surveysAttached: Array<number>;
  meetingsAttached: Array<string>;
  email_template_id: number | null | undefined;
} & NodeSchedule &
  NoteWriteback;

const initialState = {
  subject: null,
  content_json: '{}',
  content_html: null,
  from_name: null,
  from_email: null,
  to_email: null,
  cc: [],
  bcc: [],
  attachments: [],
  // We are initializing this as 4, since default marketing category id is 4.
  content_subscription_category_id: null,
  content_subscription_reason: null,
  skip_subscription_link: false,
  chatbotsAttached: [],
  surveysAttached: [],
  email_template_id: undefined,
  ...getDefaultNodeScheduleState({
    blackout_action: 'SEND_BEFORE',
  }),
  ...getDefaultNoteWritebackState(),
} as const;

export default (
  // @ts-expect-error - TS2322 - Type '{ readonly nwbEntityType: string | null | undefined; readonly nwbExternalEntityId: string | null | undefined; readonly nwbNoteAction: number | string | null | undefined; ... 28 more ...; readonly surveysAttached: readonly []; }' is not assignable to type 'EmailState'.
  state: EmailState = initialState,
  action: EmailAction,
): EmailState => {
  switch (action.type) {
    case UPDATE_EMAIL_INFO:
      const updatePayload = action.payload;
      return {
        ...state,
        ...updatePayload,
      };
    case RECEIVE_EMAIL_INFO:
      return {
        ...state,
        ...action.payload,
      };

    case UPDATE_NODE_SCHEDULE:
      return {
        ...state,
        ...action.payload,
      };
    case UPDATE_NOTE_WRITEBACK:
      return {
        ...state,
        ...action.payload,
      };
    case RESET:
      // @ts-expect-error - TS2322 - Type '{ nwbEntityType: string | null | undefined; nwbExternalEntityId: string | null | undefined; nwbNoteAction: number | string | null | undefined; nwbEnabled: boolean; date_type?: string; ... 26 more ...; surveysAttached: readonly []; }' is not assignable to type 'EmailState'.
      return {...initialState};
  }
  return state;
};
